import { api } from 'src/config/api';
import { GetCourseListResponse } from 'src/interfaces/courseList';

export const getCourseList = async (): Promise<GetCourseListResponse> => {
  const response = await api.get('course');
  return response?.data;
};
